import React, { useRef, useState } from "react";
import { useTranslation } from 'react-i18next';

import "./Link.scss";

import classNames from "classnames";

import { ReactComponent as EditIcon } from "static/icons/edit.svg";
import { ReactComponent as LinkIcon } from "static/icons/link.svg";

const LinkCell = ({ contenteditable, onDoubleClick, onBlur, link, style, color, setNodeRef, rowIndex, ...rest }) => {
  const { t } = useTranslation();

  const linkRef = useRef();

  const [isShowTooltip, setIsShowTooltip] = useState(false);

  const onClickHandler = () => {
    linkRef.current.click();
  };

  return (
    <td
      {...rest}
      contenteditable={`${contenteditable}`}
      ref={setNodeRef}
      onBlur={onBlur}
      style={style}
      onClick={onDoubleClick}
      onMouseEnter={() => setIsShowTooltip(true)}
      onMouseLeave={() => setIsShowTooltip(false)}
      className={classNames("link-cell", { "link-cell_hover": isShowTooltip })}
    >
      {contenteditable ? link :
        <>
          {isShowTooltip && link ? (
            <div className={classNames({
              "link-cell__tooltip": true,
              "link-cell__tooltip-bottom": rowIndex === 0,
            })}>
              <div onClick={onClickHandler} className="link-cell__tooltip__open">
                <LinkIcon />
                <span>{t('open')}</span>
              </div>

              <div onClick={onClickHandler} className="link-cell__tooltip__content">
                <span>{link}</span>
              </div>

              <div onClick={onDoubleClick} className="link-cell__tooltip__edit">
                <EditIcon />
                <span>{t('edit')}</span>
              </div>
            </div>
          ) : null}

          <a
            ref={linkRef}
            target="_blank"
            rel="noopener"
            href={link}
            style={{ color: color !== "#000" ? color : undefined }}
          >
            {link}
          </a>
        </>
      }
    </td>
  );
};

export default LinkCell;
